import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ReviewsPage() {
  const reviews = [
    {
      name: 'Donovan Y',
      location: 'Google Review',
      rating: 5,
      date: 'January 2026',
      text: 'Sincerely the absolute top amazing people and services that I have ever experienced in my 33 years in the entertainment industry. Staff treats you like family. The Clown is world famous, kindest, loving, compassionate, considerate. Plus the Lead Clown was on my favorite show on TV, American Pickers. They have given me good memories that will never fade.',
      avatar: 'https://ui-avatars.com/api/?name=Donovan+Y&background=DC2626&color=fff'
    },
    {
      name: 'Roxann P',
      location: 'Facebook Review',
      rating: 5,
      date: 'December 2025',
      text: 'I would like to thank Fun Affairs for the amazing job they did for the end of the year bash for Paxinosa. Everyone was so helpful with our planning and exceeded our expectations. I would recommend them to anyone. Look forward to working with you in the future.',
      avatar: 'https://ui-avatars.com/api/?name=Roxann+P&background=DC2626&color=fff'
    },
    {
      name: 'Cindi K',
      location: 'Facebook Review',
      rating: 5,
      date: 'November 2025',
      text: 'Always a great performance by Balloons the Clown. They\'ve supplied our event for many many years. Professional place but yet down to earth and friendly! Everything always ran smoothly! Thanks Fun Affairs!',
      avatar: 'https://ui-avatars.com/api/?name=Cindi+K&background=DC2626&color=fff'
    },
    {
      name: 'Chelsea M',
      location: 'Facebook Review',
      rating: 5,
      date: 'October 2025',
      text: 'Thank you to Neal and Fun Affairs for making my daughter\'s 4th birthday spectacular!! The bounce house was a huge hit with all the kids. Setup was quick and professional, and pickup was just as smooth. Highly recommend for any party!',
      avatar: 'https://ui-avatars.com/api/?name=Chelsea+M&background=DC2626&color=fff'
    },
    {
      name: 'YMCA Of Easton',
      location: 'Facebook Review',
      rating: 5,
      date: 'September 2025',
      text: 'We are sending a BIG THANK YOU to Fun Affairs for donating a dozen cakes for our Campers! They all loved being little "professional cake decorators" and made an awesome camp memory together! Your generosity and community support mean so much.',
      avatar: 'https://ui-avatars.com/api/?name=YMCA&background=DC2626&color=fff'
    },
    {
      name: 'Sarah T',
      location: 'Google Review',
      rating: 5,
      date: 'August 2025',
      text: 'Fun Affairs made our corporate event a huge success! The interactive games were perfect for team building and everyone had a blast. Professional setup and takedown. The staff was friendly and accommodating. Will definitely use them again!',
      avatar: 'https://ui-avatars.com/api/?name=Sarah+T&background=DC2626&color=fff'
    },
    {
      name: 'Michael R',
      location: 'Google Review',
      rating: 5,
      date: 'July 2025',
      text: 'Excellent service from start to finish! We rented a bounce house and games for our neighborhood block party. Everything was clean, safe, and the kids loved it. Fair pricing and great communication. Highly recommend Fun Affairs!',
      avatar: 'https://ui-avatars.com/api/?name=Michael+R&background=DC2626&color=fff'
    },
    {
      name: 'Jennifer L',
      location: 'Facebook Review',
      rating: 5,
      date: 'June 2025',
      text: 'We used Fun Affairs for our school carnival and they were fantastic! They provided multiple games, a bounce house, and cotton candy machine. The kids had an amazing time. Professional, reliable, and reasonably priced. Thank you!',
      avatar: 'https://ui-avatars.com/api/?name=Jennifer+L&background=DC2626&color=fff'
    },
    {
      name: 'David M',
      location: 'Google Review',
      rating: 5,
      date: 'May 2025',
      text: 'Outstanding service! We needed a last-minute rental for a birthday party and Fun Affairs came through. Same-day delivery, professional setup, and the equipment was spotless. The kids had a blast. Can\'t thank them enough!',
      avatar: 'https://ui-avatars.com/api/?name=David+M&background=DC2626&color=fff'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Customer Reviews & Testimonials
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto mb-8">
              See what our satisfied customers have to say about their experience with Fun Affairs.
            </p>
            <div className="flex items-center justify-center space-x-2 mb-4">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-4xl text-amber-400"></i>
              ))}
            </div>
            <p className="text-2xl font-bold text-white">5.0 out of 5 stars</p>
            <p className="text-lg text-white/90">Based on 150+ reviews</p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
              {reviews.map((review, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-200"
                >
                  <div className="flex items-center space-x-1 mb-4">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-xl text-amber-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-gray-700 mb-6 leading-relaxed">
                    "{review.text}"
                  </p>
                  <div className="flex items-center space-x-3 mb-3">
                    <img 
                      src={review.avatar}
                      alt={review.name}
                      className="w-12 h-12 rounded-full"
                    />
                    <div>
                      <p className="font-bold text-gray-900 text-sm">{review.name}</p>
                      <p className="text-xs text-gray-600">{review.location}</p>
                    </div>
                  </div>
                  <p className="text-xs text-gray-500">{review.date}</p>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-12 text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
                Leave Us a Review
              </h2>
              <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
                Had a great experience with Fun Affairs? We'd love to hear from you! Share your feedback on Google or Facebook.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a 
                  href="https://www.google.com/search?q=Fun+Affairs" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  <i className="ri-google-fill mr-2"></i>
                  Review on Google
                </a>
                <a 
                  href="https://www.facebook.com/FunAffairs/reviews" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  <i className="ri-facebook-fill mr-2"></i>
                  Review on Facebook
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Ready to Experience Our 5-Star Service?
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Join hundreds of satisfied customers and make your event unforgettable with Fun Affairs.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link 
                to="/contact" 
                className="bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap w-full sm:w-auto"
              >
                Get Free Quote
              </Link>
              <a 
                href="tel:6102532835" 
                className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
              >
                <i className="ri-phone-fill mr-2"></i>
                (610) 253-2835
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}